import forEachElement from './forEachElement';

/**
 * Removes one more classes from the given selector or elements
 * @param elements The string selector or element(s) you wish to remove classes from
 * @param classNames One or more classes you wish to add to each element
 */
export default function removeClass(elements, ...classNames) {
  forEachElement(elements, el =>
    classNames.forEach(className =>
      el.classList.remove(className)
    )
  );
}



// WEBPACK FOOTER //
// ./client/app/scripts/principles/selectors/removeClass.js